// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notfound-box[data-v-46a88b29] {\n  background-color: #853462;\n  border-radius: 10px;\n  color: white;\n  padding: 10px;\n}\n.title-error[data-v-46a88b29] {\n  font-size: 100px;\n}\n.go-home[data-v-46a88b29] {\n  background-color: #68294c;\n  color: white;\n  border: none;\n  height: 40px;\n  width: 120px;\n  border-radius: 10px;\n}\n.go-home[data-v-46a88b29]:hover {\n    background-color: #4d1e38;\n}\n", ""]);
// Exports
module.exports = exports;
